import axios from '@/http/index';

const base = '';
// 打印
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);
// 获取打印机列表
export const getPrintSetList = (param) => axios.get(`${base}/erp/print/getPrintSetList`, param).then((res) => res.data);

// (4.7)获得部分支付付款记录
export const getPartPayList = (param) => axios.get(`${base}/erp/customerOrder/getPartPayList`, param).then((res) => res.data);

// (5.2)获取退款授权二维码
export const obtainGainQRCode = (param) => axios.get(`${base}/erp/refund/obtainGainQRCode`, param).then((res) => res.data);

// (5.2)获得退款状态
export const getRefundPayStatus = (param) => axios.get(`${base}/erp/refund/getRefundPayStatus`, param).then((res) => res.data);

// (5.2)获得退款授权状态
export const getRefundPayAuthStatus = (param) => axios.get(`${base}/erp/refund/getRefundPayAuthStatus`, param).then((res) => res.data);

// (5.2)获得退款项目列表
export const getRefundItemMsg = (param) => axios.get(`${base}/erp/refund/getRefundItemMsg`, param).then((res) => res.data);

// (5.2)提交保存退款信息
export const saveOrUpdateRefundMsg = (param) => axios.post(`${base}/erp/refund/saveOrUpdateRefundMsg`, param).then((res) => res.data);

// (5.2)获得订单退款记录
export const getRefundPayList = (param) => axios.get(`${base}/erp/refund/getRefundPayList`, param).then((res) => res.data);
// (5.7)获取针式打印(拖拽)设置的模板
export const getDragPrintTemplate = (param) => axios.get(`${base}/erp/print/getDragPrintTemplate`, param).then((res) => res.data);
// (5.7)针式打印(拖拽)
export const dragPrint = (param) => axios.get(`${base}/erp/print/dragPrint`, param).then((res) => res.data);
